import React from 'react';

// A browser workspace can survive across releases. If an old local view is
// incompatible with a new editor, show a recovery action rather than white.
export default class AppErrorBoundary extends React.Component {
 constructor(props){super(props);this.state={error:null};}
 static getDerivedStateFromError(error){return {error};}
 componentDidCatch(error,info){
  console.error('Takefold rendering error:',error,info?.componentStack||'');
 }
 render(){
  if(!this.state.error)return this.props.children;
  const openProjects=()=>{
   // Only reset UI navigation (session storage). Do not touch credentials,
   // saved cloud projects, cached media, or unsaved local interview data.
   try{
    sessionStorage.removeItem('cutscript-screen');
    sessionStorage.removeItem('cutscript-mode');
   }catch{/* Recovery query is also handled by App initializers. */}
   const url=new URL(window.location.href);
   url.pathname='/';url.hash='';url.searchParams.set('recover','1');
   window.location.replace(url.toString());
  };
  return <main style={{minHeight:'75vh',display:'grid',placeItems:'center',
    padding:'24px',fontFamily:'Inter,system-ui,sans-serif',color:'#253333'}}>
   <section role="alert" style={{width:'min(100%,530px)',background:'#fff',
     border:'1px solid #dde4e2',borderRadius:'12px',padding:'30px',
     boxShadow:'0 14px 35px #0000000d'}}>
    <div style={{fontSize:'12px',fontWeight:800,color:'#32865b',marginBottom:8}}>TAKEFOLD</div>
    <h1 style={{fontSize:'24px',letterSpacing:'-.025em',margin:'0 0 12px'}}>This workspace couldn't open</h1>
    <p style={{lineHeight:1.6,margin:'0 0 20px',color:'#4c5958'}}>
     Your project has not been deleted. Try opening the project list safely; this
     resets only the current editor view, not your sign-in or saved projects.
    </p>
    <button type="button" onClick={openProjects}
     style={{padding:'12px 16px',background:'#218454',color:'#fff',fontWeight:700,
      border:'none',borderRadius:8,cursor:'pointer'}}>
     Open my projects safely
    </button>
    <details style={{marginTop:20,fontSize:12,color:'#63736f'}}>
     <summary style={{cursor:'pointer'}}>Technical details</summary>
     <pre style={{whiteSpace:'pre-wrap',wordBreak:'break-word',marginTop:9,
      padding:12,background:'#f4f6f5',borderRadius:6}}>{String(this.state.error?.message||this.state.error||'Unknown error')}</pre>
    </details>
   </section>
  </main>;
 }
}
